import React, { useState } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import DatePicker from "react-datepicker";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";

const Createpastorder = () => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState();

  const [count, setCount] = useState(0);
  const handleIncrement = (e) => {
    setCount(count + 1);
  };

  const handleDecrement = (e) => {
    setCount(count - 1);
    if (count == 0) {
      setCount("0");
    }
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="container-fluid">
      <div className="dbMain  pastorder">
        <Leftpanel />
        <div className="dbRight">
          <Header
            link="/pastorder"
            breadcm=""
            title={t("Create Past Order")}
            description=""
          />

          <Form>
            <div className="commonBase mb-3">
              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="4" className="mb-3">
                  <Form.Select
                    className="form-control"
                    aria-label="Default select example"
                  >
                    <option>{t("select_supplier")}</option>
                    <option value="1">{t("delivered")}</option>
                    <option value="2">{t("not_delivered")}</option>
                  </Form.Select>
                </Col>
                <Col sm="4" className="mb-3">
                  <div className="dateSelect delDate">
                    <DatePicker
                      selectsStart
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      startDate={startDate}
                      placeholderText={t("select_date")}
                    />
                  </div>
                </Col>

                <Col sm="4" className="mb-3">
                  <Form.Select
                    className="form-control"
                    aria-label="Default select example"
                  >
                    <option>{t("select_department")}</option>
                    <option value="1">{t("delivered")}</option>
                    <option value="2">{t("not_delivered")}</option>
                  </Form.Select>
                  <div className="namecard mb-2 mt-3">
                    <p>{t("name")}: John Doe</p>
                    <p>{t("short_name")}: John</p>
                    <p>{t("email_id")}: john@gmail.com</p>
                    <p>{t("phone")}: 2589685</p>
                  </div>
                  <div className="namecard mb-2">
                    <p>{t("name")}: John Doe</p>
                    <p>{t("short_name")}: John</p>
                    <p>{t("email_id")}: john@gmail.com</p>
                    <p>{t("phone")}: 2589685</p>
                  </div>
                </Col>
              </Form.Group>
            </div>

            <div className="commonBase mb-3">
              <h6>{t("create_new_product")}</h6>
              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="3" className="mb-3">
                  <Form.Control type="text" placeholder={t("product_id")} />
                </Col>
                <Col sm="3" className="mb-3">
                  <Form.Control type="text" placeholder={t("product_name")} />
                </Col>
                <Col sm="3" className="mb-3">
                  <Form.Control type="text" placeholder={t("select_qty")} />
                </Col>
                <Col sm="3" className="mb-3">
                  <Form.Control type="text" placeholder={t("enter_price")} />
                </Col>
              </Form.Group>
              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="3" className="mb-3">
                  <Form.Control type="text" placeholder={t("vat")} />
                </Col>
                <Col sm="3" className="mb-3">
                  <Form.Control type="text" placeholder={t("discount")} />
                </Col>
                <Col sm="3" className="mb-3">
                  <Form.Control type="text" placeholder={t("total_amount")} />
                </Col>
                <Col sm="3" className="mb-3">
                  <button className="commonButton">{t("add")}</button>
                </Col>
              </Form.Group>
            </div>
          </Form>

          <div className="commonBase mb-3">
            <div className="pastOrderproducttop">
              <h6>{t("select_product")}</h6>
              <div className="ppoTxt">
                <span>
                  {t("total_carbon_footprint")} :{" "}
                  <span className="cgbtn">2000</span>
                </span>
                &nbsp;&nbsp;
                <span>
                  {t("total_amount")} : <span className="cgbtn">Íkr 3000</span>
                </span>
                &nbsp;&nbsp;
                <div className="orderCart">
                  <button onClick={handleShow}>
                    <i className="fa-regular fa-cart-shopping"></i>
                    <span className="pop">20</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="prdviewTable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("product_id")}</th>
                    <th>{t("product_name")}</th>
                    <th>{t("price")}</th>
                    <th>{t("carbon_footprint")}</th>
                    <th>{t("vat")}</th>
                    <th>{t("discount")}</th>
                    <th>{t("select_qty")}</th>
                    <th>{t("total_amount")}</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td data-label={t("product_id")}>
                      <Link to="/pastorderdetail"> UNI258965</Link>
                    </td>
                    <td data-label={t("product_name")}>Apple</td>
                    <td data-label={t("price")}>
                      <span className="defltBg">Íkr 203.00</span>
                    </td>
                    <td data-label={t("carbon_footprint")}>155</td>
                    <td data-label={t("vat")}>
                      <span className="defltBg">10%</span>
                    </td>
                    <td data-label={t("discount")}>
                      <span className="defltBg">20%</span>
                    </td>
                    <td data-label={t("select_qty")}>
                      <div className="defltBg">
                        <button onClick={handleDecrement}>-</button>
                        <span style={{ padding: "0 5px;" }}>{count}</span>
                        <button onClick={handleIncrement}>+</button>
                      </div>
                    </td>
                    <td data-label={t("total_amount")}>Íkr 1500</td>
                    <td data-label={t("action")}>
                      <i className="fa-regular fa-cart-shopping"></i>
                    </td>
                  </tr>
                  <tr>
                    <td data-label={t("product_id")}>
                      <Link to="/pastorderdetail"> UNI258965</Link>
                    </td>
                    <td data-label={t("product_name")}>Apple</td>
                    <td data-label={t("price")}>
                      <span className="defltBg">Íkr 203.00</span>
                    </td>
                    <td data-label={t("carbon_footprint")}>155</td>
                    <td data-label={t("vat")}>
                      <span className="defltBg">10%</span>
                    </td>
                    <td data-label={t("discount")}>
                      <span className="defltBg">20%</span>
                    </td>
                    <td data-label={t("select_qty")}>
                      <div className="defltBg">
                        <button onClick={handleDecrement}>-</button>
                        <span style={{ padding: "0 5px;" }}>{count}</span>
                        <button onClick={handleIncrement}>+</button>
                      </div>
                    </td>
                    <td data-label={t("total_amount")}>Íkr 1500</td>
                    <td data-label={t("action")}>
                      <i className="fa-regular fa-cart-shopping"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <button className="commonButton mt-3">
              {t("create_past_order")}
            </button>
            &nbsp;&nbsp;
            <button className="commonButton mt-3">
              {t("create_order_and_save_basket")}
            </button>
          </div>
          {/* <button className='commonButton'>Send To Supplier</button> */}
        </div>
      </div>

      <Modal
        size="lg"
        centered
        show={show}
        onHide={handleClose}
        className="pastorderModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>Cart</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="prdviewTable respTable">
            <table>
              <thead>
                <tr>
                  <th>Product ID</th>
                  <th>Product Name</th>
                  <th>Price</th>
                  <th>Carbon footprint</th>
                  <th>VAT %</th>
                  <th>Discount %</th>
                  <th>Updated date</th>
                  <th>Select qty</th>
                  <th>Total amount</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td data-label="Product ID">
                    <Link to="/pastorderdetail"> UNI258965</Link>
                  </td>
                  <td data-label="Product Name">Apple</td>
                  <td data-label="Price">
                    <span className="defltBg">Íkr 203.00</span>
                  </td>
                  <td data-label="Carbon footprint">155</td>
                  <td data-label="VAT %">
                    <span className="defltBg">10%</span>
                  </td>
                  <td data-label="Discount %">
                    <span className="defltBg">20%</span>
                  </td>
                  <td data-label="Updated date">12-11-2023</td>
                  <td data-label="Select qty">
                    <div className="defltBg">
                      <button onClick={handleDecrement}>-</button>
                      <span style={{ padding: "0 5px;" }}>{count}</span>
                      <button onClick={handleIncrement}>+</button>
                    </div>
                  </td>
                  <td data-label="Total amount">Íkr 1500</td>
                  <td data-label="Action">
                    <button className="delIcn">
                      <i className="fa-solid fa-trash-can"></i>
                    </button>
                  </td>
                </tr>
                <tr>
                  <td data-label="Product ID">UNI258965</td>
                  <td data-label="Product Name">Apple</td>
                  <td data-label="Price">
                    <span className="defltBg">Íkr 203.00</span>
                  </td>
                  <td data-label="Carbon footprint">155</td>
                  <td data-label="VAT %">
                    <span className="defltBg">10%</span>
                  </td>
                  <td data-label="Discount %">
                    <span className="defltBg">20%</span>
                  </td>
                  <td data-label="Updated date">12-11-2023</td>
                  <td data-label="Select qty">
                    <div className="defltBg">
                      <button onClick={handleDecrement}>-</button>
                      <span style={{ padding: "0 5px;" }}>{count}</span>
                      <button onClick={handleIncrement}>+</button>
                    </div>
                  </td>
                  <td data-label="Total amount">Íkr 1500</td>
                  <td data-label="Action">
                    <button className="delIcn">
                      <i className="fa-solid fa-trash-can"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="orderComment pt-3">
            <h6 className="pb-2">Add Comments</h6>
            <textarea></textarea>
            <button className="commonButton mt-3" style={{ float: "right" }}>
              Add
            </button>
            &nbsp;&nbsp;
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start">
          <button className="commonButton mt-3">Save Basket</button>&nbsp;&nbsp;
          <button className="commonButton mt-3">
            Save Basket & Create Order
          </button>
          <button className="commonButton mt-3">Create Order</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Createpastorder;
